import WifiBoxAddForm  from './WifiBoxAddForm';

export default WifiBoxAddForm;
